import { bus } from '@/utils/bus.js'

function getPrice(prolong, category) {
    let payment = 1
    if (category.group) payment = 0.5

    if (!prolong.discountPossible) return prolong.price
    else return prolong.price * payment
}

function doShowPaymentModal(requestData) {
    bus.$emit('showPaymentModal', requestData)
}

export { getPrice, doShowPaymentModal }
